// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1d_b5","row":"ProcedureTreatmentSummary_row__1d0CK"};